import { render } from "./GlazingWall.vue?vue&type=template&id=06b3c1d0&scoped=true&ts=true"
import script from "./GlazingWall.vue?vue&type=script&lang=ts"
export * from "./GlazingWall.vue?vue&type=script&lang=ts"

import "./GlazingWall.vue?vue&type=style&index=0&id=06b3c1d0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06b3c1d0"]])

export default __exports__